<script lang="ts">
  import { BulletPoint } from '../../../components/index';

  export let text: string;
  export let href: string | undefined = undefined;
  export let iconName: string | undefined = undefined;
  export let target: string | undefined = undefined;
  export let onClick: (() => void) | undefined = undefined;
  export let type: 'button' | 'submit' = 'button';

  const baseStyles =
    'inline-flex items-center justify-center w-full px-5 group py-3 gap-2 border-0 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-300 font-bold leading-normal text-white bg-[var(--color-accent)] hover:bg-[color-mix(in srgb, var(--color-accent), #000 50%)] hover:shadow-md';

  function handleClick(event: MouseEvent) {
    if (onClick) {
      onClick();
    }
  }
</script>

<template>
  {#if href}
    <a
      {href}
      {target}
      class={baseStyles}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
    >
      <span>{@html text}</span>
      {#if iconName}
        <span
          class="h-5 w-5 min-w-5 transition-all duration-300 group-hover:-translate-y-px"
        >
          <BulletPoint bulletIcon={iconName} />
        </span>
      {/if}
    </a>
  {:else}
    <button {type} on:click={handleClick} class={baseStyles}>
      <span>{@html text}</span>
      {#if iconName}
        <span class="transition-all duration-300 group-hover:-translate-y-px">
          <BulletPoint bulletIcon={iconName} />
        </span>
      {/if}
    </button>
  {/if}
</template>
